import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as isNotFavoriteHeart } from '@fortawesome/free-regular-svg-icons';
import { faHeart as isFavoriteHeart } from '@fortawesome/free-solid-svg-icons';
import getAxiosInstance from 'config/api';
import { connect } from 'react-redux';

import {
  addFavoriteArticle as _addFavoriteArticle,
  removeFavoriteArticle as _removeFavoriteArticle,
} from 'shared/actions/my-favorite-articles.action';

function ArticleHeart({
  article,
  addFavoriteArticle,
  removeFavoriteArticle,
  size,
  sessionUser,
}) {
  const [isFavorite, setIsFavorite] = useState(
    !_.isEmpty(article.purchaseLists),
  );
  const [isHovering, setIsHovering] = useState(false);

  const addToMyFavorites = async () => {
    await getAxiosInstance().post('actions', {
      action: 'v1.purchaseList.addToMyFavorites',
      payload: { article },
    });
    setIsHovering(false);
    setIsFavorite(true);
    addFavoriteArticle(article);
  };
  const removeFromMyFavorites = async () => {
    await getAxiosInstance().post('actions', {
      action: 'v1.purchaseList.removeFromMyFavorites',
      payload: { article },
    });
    setIsHovering(false);
    setIsFavorite(false);
    removeFavoriteArticle(article);
  };

  useEffect(() => {
    setIsFavorite(!_.isEmpty(article.purchaseLists));
  }, [article]);

  if (_.isEmpty(sessionUser)) return null;
  return (
    <div>
      <span
        onClick={isFavorite ? removeFromMyFavorites : addToMyFavorites}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <FontAwesomeIcon
          icon={isFavorite ? isFavoriteHeart : isNotFavoriteHeart}
          size={size}
          className={`heart-favorite text-dark`}
          beat={isHovering}
        />
      </span>
    </div>
  );
}

const mapDispatchToProps = {
  addFavoriteArticle: _addFavoriteArticle,
  removeFavoriteArticle: _removeFavoriteArticle,
};

const mapStateToProps = ({ authentication, shopConfig }) => ({
  sessionUser: authentication.sessionUser,
  shopConfig,
});

ArticleHeart.propTypes = {
  article: PropTypes.object.isRequired,
  addFavoriteArticle: PropTypes.func.isRequired,
  removeFavoriteArticle: PropTypes.func.isRequired,
  size: PropTypes.string,
};

ArticleHeart.defaultProps = {
  size: 'lg',
};
export default connect(mapStateToProps, mapDispatchToProps)(ArticleHeart);
